/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of Spinner
 */ export const renderSpinner_unstable = (state)=>{
    assertSlots(state);
    const { labelPosition , shouldRenderSpinner  } = state;
    return /*#__PURE__*/ createElement(state.root, null, state.label && shouldRenderSpinner && (labelPosition === 'above' || labelPosition === 'before') && /*#__PURE__*/ createElement(state.label, null), state.spinner && shouldRenderSpinner && /*#__PURE__*/ createElement(state.spinner, null), state.label && shouldRenderSpinner && (labelPosition === 'below' || labelPosition === 'after') && /*#__PURE__*/ createElement(state.label, null));
};
